import {Component, OnDestroy, OnInit} from '@angular/core';
import {FilterParam} from '@ngx-ivengi/crud/request-params';
import {Building} from '../building/building.model';
import {BuildingService} from '../building/building.service';
import {RequestParams} from '@ngx-ivengi/crud';
import {UIRouter} from '@uirouter/angular';
import {Contact} from '../contact/contact.model';
import {ContactService} from '../contact/contact.service';

@Component({
  templateUrl: './assignment-building-form.component.html'
})
export class AssignmentBuildingFormComponent implements OnInit, OnDestroy {

  public building: Building;
  public buildings: Building[] = [];
  public loaded: boolean = false;

  private linkedBuildingIds: Array<string|number>;

  constructor(
    private router: UIRouter,
    private buildingService: BuildingService,
    private contactService: ContactService
  ) {}

  public ngOnInit(): void {
    const requestParams = new RequestParams();
    requestParams.pagination.limit = 0;

    this.buildingService.clearRoutePrefix();
    this.buildingService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);

    this.buildingService.getAll(requestParams).subscribe((linkedBuildings: Building[]) => {
      this.linkedBuildingIds = linkedBuildings.map((building) => {
        return <string>building.buildingId;
      });

        const buildingRequestParams = new RequestParams();
        buildingRequestParams.pagination.limit = 0;

        this.buildingService.clearRoutePrefix();
        this.buildingService.getAll(buildingRequestParams).map((buildings: Building[]) => {
          return buildings.filter((building) => {
            return (this.linkedBuildingIds.indexOf(building.id) === -1);
          });
        }).subscribe((buildings: Building[]) => {
          this.buildings = buildings;
          this.loaded = true;
        });
      // });
    });
  }

  public ngOnDestroy(): void {
    this.buildingService.clearRoutePrefix();
  }

  public save() {
    this.buildingService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
    this.buildingService.add(this.building).subscribe((response) => {
      const currentStateParts = this.router.stateService.$current.name.split('.');
      currentStateParts.pop();
      const parentState = currentStateParts.join('.');
      this.buildingService.clearRoutePrefix();
      this.router.stateService.go(parentState, this.router.stateService.params, {reload: true});
    });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/assignment/assignment-building-form.component.ts